import { updateBlog } from './editBlog-events';

const editBlogPage = document.querySelector('#edit-blog');

if (editBlogPage) {
  const editBlogForm = document.querySelector('#edit-blog #createBlogForm');

  editBlogForm.addEventListener('submit', updateBlog);
}
